<template>
  <div class="calendar-wrapper">
    <full-calendar
      :plugins="calendarPlugins"
      initial-view="timeGridDay"
      :events="calendarEvents"
      :now-indicator="true"
      :scroll-time="scrollTime"
      :header="header"
      :slot-duration="'00:05:00'"
      :min-time="'00:00:00'"
      :max-time="'24:00:00'"
      :locale="calendarLocale"
      @event-click="handleEventClick"
      @date-click="handleDateClick"
    />
  </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue3'
import dayGridPlugin from '@fullcalendar/daygrid'  
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import allLocales from '@fullcalendar/core/locales-all'

export default {
  name: 'CalendarView',
  components: { FullCalendar },
  data() {
    const now = new Date()
    const hh = now.getHours().toString().padStart(2, '0')
    const mm = now.getMinutes().toString().padStart(2, '0')
    const scrollTime = `${hh}:${mm}:00`
    const userLang = navigator.language || 'en'
    const localeCode = userLang.split('-')[0]
    return {
     
      scrollTime,
      calendarEvents: [],   
      calendarPlugins: [ dayGridPlugin, timeGridPlugin, interactionPlugin ],
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay'
      },
      calendarLocale: allLocales.find(l => l.code === localeCode) || allLocales.find(l => l.code === 'en')
    }
  },
  mounted() {
    this.loadCalendar()
  },
  methods: {
    async loadCalendar() {
      try {
        const resp = await this.$http.get('/gym/calendar') // sin params!
        const items = resp.data.sessions || []

        this.calendarEvents = items.map(item => {
          const start = item.start_at 
          const end = item.end_at

          return {
            id: item.calendar_id || item.id,
            title: `${item.session?.name || ''} - ${(item.session?.instructor_name?.[0]?.name || '')} - ${(item.session?.length || '')}`,
            start: start.includes('T') ? start : start.replace(' ', 'T') + 'Z',
            end: end.includes('T') ? end : end.replace(' ', 'T') + 'Z',
            backgroundColor: '#be374b',
            borderColor: '#be374b',
            textColor: '#ffffff',
            extendedProps: { session: item.session || null }
          }
        })
      } catch (e) {
        // console.error(e)
      }
    },

    handleEventClick(info) {
      const ev = info.event
      const calendarSessionId = ev.id

      this.$router.push({
        name: 'CalendarSessionForm',
        query: { calendarSessionId }
      })
    },

    handleDateClick(info) {
      const dateStr = info.date.toISOString().slice(0,16) 
      this.$router.push({
        name: 'CalendarSessionForm',
        query: { date: dateStr }
      })
    }
  }
}
</script>

<style scoped>
.calendar-wrapper {
  padding: 12px;
}

</style>
